import { useStyles } from "./LeaderboardActivity.style";
import {
  Header,
  Icon,
  Typography,
  TypographyVariant,
  useCustomNavigate,
} from "@onmo/ui";
import { useParams } from "react-router-dom";
import { globalLeaderboardsGQL } from "../../graphql";
import { useQuery } from "@apollo/client";
import { formatDate } from "../../models/time";
import LeaderboardUsers from "../../components/common/LeaderboardUsers/LeaderboardUsers";
import { LeaderboardType } from "../../constants/user";
import { useTranslation } from "react-i18next";

const LeaderboardActivity: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { handleBack } = useCustomNavigate();
  const { leaderboardId } = useParams<{ leaderboardId: string }>();
  const { data, fetchMore } = useQuery(globalLeaderboardsGQL, {
    fetchPolicy: "no-cache",
    variables: { input: { leaderboardId: leaderboardId } },
  });

  const searchParams = new URLSearchParams(window.location.search);
  const leaderboardType = searchParams.get("type");

  const globalLeaderboards = data?.leaderboard;

  const loadMoreUser = () => {
    if (
      data.leaderboard.items.length >= 200 ||
      data.leaderboard.items.length === data.leaderboard.total
    )
      return;

    fetchMore({
      variables: {
        input: {
          leaderboardId: leaderboardId,
          page: {
            limit: 20,
            offset: data?.leaderboard?.items?.length,
          },
        },
      },
    });
  };

  return (
    <div className={classes.root}>
      <Header
        title={`${leaderboardType} ${t("leaderboard")}`}
        leftElement={
          <Icon name="icon-bold-arrow-left-3" onClick={() => handleBack()} />
        }
      />
      <div className={classes.content}>
        <div className={classes.endTime}>
          <Typography variant={TypographyVariant.BodyB4Regular}>
            {t("ends_on")}
          </Typography>
          {globalLeaderboards?.endDate && (
            <Typography variant={TypographyVariant.BodyB5Regular}>
              <Icon name="icon-timer" className={classes.iconTimer} size={14} />
              {formatDate(globalLeaderboards?.endDate, "dd/mm/yyyy")}
            </Typography>
          )}
        </div>
        <LeaderboardUsers
          leaderboards={globalLeaderboards}
          loadMoreUser={loadMoreUser}
          type={leaderboardType as LeaderboardType}
        />
      </div>
    </div>
  );
};
export default LeaderboardActivity;
